import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function EmotionalClose() {
  return <section className="py-16 md:py-20 px-4 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-27">
      <div className="absolute inset-0 bg-leaf-pattern opacity-40 pointer-events-none" data-id="element-28" />
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-brand-cream to-transparent opacity-10" data-id="element-29" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-5" data-id="element-31">
          <p className="text-xl md:text-2xl text-brand-cream/80 leading-relaxed" data-id="element-32">
            Llevas demasiado tiempo peleando con tu mente a las 3pm.
          </p>
          <p className="text-xl md:text-2xl text-brand-cream/80 leading-relaxed" data-id="element-33">
            Demasiado tiempo prometiéndote que mañana va a ser diferente.
          </p>
          <p className="text-xl md:text-2xl text-brand-cream/80 leading-relaxed" data-id="element-34">
            Demasiado tiempo sintiéndote culpable por algo que no es tu culpa.
          </p>

          <div className="py-4" data-id="element-35">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-brand-gold mb-3" data-id="element-36">
              El antojo no es el enemigo.
            </h2>
            <p className="text-2xl text-brand-lightGold font-medium" data-id="element-37">
              Es una señal. Una señal que ahora ya sabes cómo leer — y cómo
              responder.
            </p>
          </div>

          <p className="text-lg text-brand-cream/70 mb-6" data-id="element-38">
            No necesitas más fuerza de voluntad. Necesitas el snack correcto en
            el momento correcto. Y ahora lo tienes.
          </p>

          <div className="mb-6" data-id="element-39">
            <p className="text-3xl font-heading italic text-brand-cream" data-id="element-40">
              Come rico. Come inteligente. Vive sin antojos.
            </p>
          </div>

          <CTAButton pulsing className="px-10 py-5 text-xl w-full md:w-auto" data-id="element-41">
            SÍ, ME MEREZCO COMER RICO SIN CULPA
          </CTAButton>

          <p className="mt-4 text-sm text-brand-cream/50" data-id="element-42">
            Acceso inmediato • PDF • Solo 48 horas
          </p>
        </motion.div>
      </div>
    </section>;
}